export default {
  namespaced: true,
  state: {
    engine: null,
    bbox: {
      west: null,
      south: null,
      east: null,
      north: null
    }
  },
  mutations: {
    SET_ENGINE(state, payload) {
      state.engine = payload;
    },
    setBBox(state, payload) {
      state.bbox = payload;
    }
  },
  actions: {
    setEngine({ commit }, payload) {
      commit("SET_ENGINE", payload);
    },
  },
};
